var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKraken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    transform: "translate(-65.000000, -24.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(65.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9964832,0 C9.39735269,0 0,9.11917531 0,20.3663948 L0,29.0927818 C0,30.6995672 1.34340172,32 2.99584756,32 C4.65059006,32 6.00102529,30.6995672 6.00102529,29.0927818 L6.00102529,20.3663948 C6.00102529,18.7575216 7.33753704,17.4547226 8.99916951,17.4547226 C10.653912,17.4547226 11.9974573,18.7575216 11.9974573,20.3663948 L11.9974573,29.0927818 C11.9974573,30.6995672 13.340859,32 14.9956015,32 C16.6549373,32 17.998339,30.6995672 17.998339,29.0927818 L17.998339,20.3663948 C17.998339,18.7575216 19.3418843,17.4547226 20.9964832,17.4547226 C22.6581157,17.4547226 24.001661,18.7575216 24.001661,20.3663948 L24.001661,29.0927818 C24.001661,30.6995672 25.3450627,32 26.9975085,32 C28.652251,32 29.9956528,30.6995672 29.9956528,29.0927818 L29.9956528,20.3663948 C29.9956528,18.7575216 31.339198,17.4547226 33.0008305,17.4547226 C34.655573,17.4547226 35.9991182,18.7575216 35.9991182,20.3663948 L35.9991182,29.0927818 C35.9991182,30.6995672 37.34252,32 39.0018558,32 C40.6565983,32 42,30.6995672 42,29.0927818 L42,20.3663948 C42,9.11917531 32.5957573,0 20.9964832,0",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKraken);
export default __webpack_public_path__ + "static/media/kraken.1b318d369109dcc5c78107be4541eebd.svg";
export { ForwardRef as ReactComponent };